import type { AFFormCommonProps } from '@faceup/abstract-form'
import { useCustomController } from '@faceup/form'
import { FormItem } from '@faceup/ui'
import { TextAreaWithVoiceRecordings } from '../../../Components/VoiceRecording/TextAreaWithVoiceRecordings'
import type { useVoiceRecordings } from '../hooks/useVoiceRecordings'

type MoreInformationVoiceFieldProps = {
  commonProps: AFFormCommonProps
  voiceRecordings: ReturnType<typeof useVoiceRecordings>
  voiceSubmissionEnabled: boolean
  voiceRecordingButtonLabel: string
  voiceRecordingButtonMaxReachedLabel: string
  recordingLabel: (n: number) => string
}

export const MoreInformationVoiceField = ({
  commonProps,
  voiceRecordings,
  voiceSubmissionEnabled,
  voiceRecordingButtonLabel,
  voiceRecordingButtonMaxReachedLabel,
  recordingLabel,
}: MoreInformationVoiceFieldProps) => {
  const {
    formItemProps,
    inputProps: { value, onChange, ...inputProps },
  } = useCustomController(commonProps)

  return (
    <FormItem {...formItemProps}>
      <TextAreaWithVoiceRecordings
        {...inputProps}
        rows={4}
        value={typeof value === 'string' ? value : ''}
        onChange={onChange}
        voiceRecordings={voiceRecordings.recordings}
        onRemoveRecording={voiceRecordings.handleRemove}
        onVoiceRecordingButtonClick={voiceRecordings.openModal}
        voiceSubmissionEnabled={voiceSubmissionEnabled}
        recordingLabel={recordingLabel}
        voiceRecordingButtonLabel={voiceRecordingButtonLabel}
        voiceRecordingButtonMaxReachedLabel={voiceRecordingButtonMaxReachedLabel}
      />
    </FormItem>
  )
}
